import React from "react";
import { AlertCircle, Check, Loader2 } from "lucide-react";

import { dataBR } from "../lib/historico";
import { reais } from "../lib/numeros";

// Rodapé fixo: o total à esquerda e as ações no canto inferior direito.
export default function RodapeCompra({ c, emEdicao, aoCancelar, aoFinalizar }) {
  const n = c.itens.length;
  return (
    <div className="shrink-0 border-t bg-card px-4 sm:px-6 py-3" data-e2e="rodape-compra">
      <div className="max-w-[1600px] mx-auto flex flex-wrap items-center justify-between gap-3">
        <div className="min-w-0">
          <p className="text-sm text-muted-foreground">{n} {n === 1 ? "item" : "itens"} na compra</p>
          <p className="text-2xl font-bold tabular-nums leading-tight" data-e2e="total-rodape">{reais(c.total)}</p>
          {!c.paga && (
            <p className="flex items-center gap-1.5 text-xs text-amber-600 dark:text-amber-400">
              <AlertCircle className="w-3.5 h-3.5" />
              {c.vencimento ? `A pagar até ${dataBR(c.vencimento)}` : "Informe o vencimento no topo"}
            </p>
          )}
        </div>
        <div className="flex items-center gap-3 ml-auto">
          <button type="button" onClick={aoCancelar} data-e2e="cancelar-compra"
            className="h-10 px-4 rounded-lg border border-red-500/40 bg-red-500/10 text-red-500 text-sm font-medium hover:bg-red-500/20 transition">
            Cancelar
          </button>
          <button type="button" onClick={aoFinalizar} disabled={c.salvando || n === 0 || emEdicao} data-e2e="finalizar-compra"
            className="h-12 px-7 rounded-lg bg-primary text-primary-foreground font-semibold flex items-center justify-center gap-2 hover:bg-primary/90 disabled:opacity-50">
            {c.salvando ? <Loader2 className="w-5 h-5 animate-spin" /> : <Check className="w-5 h-5" />}
            {c.salvando ? "Salvando…" : c.loteId ? "Salvar alterações" : "Finalizar compra"}
          </button>
        </div>
      </div>
      {emEdicao && <p className="max-w-[1600px] mx-auto text-xs text-muted-foreground text-right">Termine a correção do item antes de finalizar.</p>}
    </div>
  );
}
